import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-like",
  "use": "icon-like-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-like\"><path d=\"M10.9 4q.9 0 1.5.6c.8.8.8 2.4 0 3.3-1 1-3.2 3.4-4.4 4.7-1.2-1.2-3.4-3.7-4.4-4.7-.8-.9-.8-2.5 0-3.3Q4.2 4 5.1 4c.9 0 1.1.2 1.5.6l.7.7.7.7.7-.7.7-.7c.4-.4 1-.6 1.5-.6m0-1c-.8 0-1.6.3-2.2.9l-.7.7-.7-.7C6.7 3.3 5.9 3 5.1 3s-1.6.3-2.2.9c-1.2 1.2-1.2 3.4 0 4.7C4.2 10 8 14 8 14s3.8-4 5.1-5.4c1.2-1.2 1.2-3.5 0-4.7-.6-.6-1.4-.9-2.2-.9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol